import type { HemerotecaModel, StrapiResponseModel } from '@/interfaces/model';
import type { HemerotecaType, StrapiListResponse } from '@/interfaces/strapi';
import { mapStrapiFile } from '@/helpers/strapi-assets-helpers';

export const hemerotecaMapper = (c: HemerotecaModel): HemerotecaType => ({
	id: c.documentId,
	autor: c.autor,
	titulo: c.titulo,
	year: c.fechaPublicacion,
	tomo: c.tomo,
	file: mapStrapiFile(c.file),
});

export const hemerotecaListMapper = (res: StrapiResponseModel<HemerotecaModel>): StrapiListResponse<HemerotecaType> => {
	const list = (res.data ?? []).map(hemerotecaMapper);

	const pagination = res.meta?.pagination ?? {
		page: 1,
		pageSize: list.length,
		pageCount: 1,
		total: list.length,
	};

	return { list, pagination };
};
